<template>
  <!-- 购物车计划卡片 -->
  <van-checkbox-group v-model="result" ref="checkboxGroup">
    <van-cell-group>
      <van-cell v-for="(item, index) in data" :key="item.id">
        <van-swipe-cell>
          <div class="fvlr">
            <van-checkbox
              checked-color="#3088c5"
              :name="item.id"
              :disabled="getDisabledBool(item)"
              shape="square"
              :ref="el => (checkboxRefs[index] = el)"
              @click.stop="alertTip(item)"
            />
            <ShopCard v-if="item._data.productType === 3" :data="item" @changeNum="changeNum($event, index, item.id)" />
            <ProductCard v-else :data="item" @changeNum="changeNum($event, index, item.id)" />
          </div>
          <template #right>
            <van-button square text="删除" type="danger" class="deleteButton" @click="deleteFn(item)" />
          </template>
        </van-swipe-cell>
      </van-cell>
    </van-cell-group>
  </van-checkbox-group>
</template>

<script>
import { reactive, toRefs, watch, inject, nextTick } from 'vue'
import { Toast } from 'vant'
import { useStore } from 'vuex'
import ProductCard from '@/components/shoppingCart/ProductCard'
import ShopCard from '@/components/shoppingCart/ShopCard'
import { deleteShoppingInf, deleteEWShopping } from '@/api/shoppingCar'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    isCheckAll: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    isManage: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProductCard,
    ShopCard
  },
  setup(props) {
    let { data, isCheckAll, type, isManage } = toRefs(props)
    const store = useStore()
    let updateCheckAll = inject('updateCheckAll')
    let afterDelete = inject('afterDelete')
    let stepperChangeNum = inject('stepperChangeNum')
    const state = reactive({
      data,
      isCheckAll,
      type,
      isManage,
      result: [],
      checkboxRefs: [],
      checkboxGroup: []
    })
    const toggle = index => {
      state.checkboxRefs[index].toggle()
    }

    const checkAll = v => {
      state.checkboxGroup.toggleAll(v)
    }
    const alertTip = v => {
      if (!v.buyAmountLimit) {
        Toast({
          message: '该商品已达到最大购买数量，无法再购买',
          position: 'bottom'
        })
      }
    }
    const changeNum = (v, i, id) => {
      // console.log('changeNum-->', v, i, state.type, state.data, state.data[i])
      for (let index = 0; index < state.result.length; index++) {
        const item = state.result[index]
        if (item.id === id) {
          state.result[index] = { ...item, num: v }
        }
      }
      stepperChangeNum({ v, i, type: state.type })
    }

    // const toggleAll = () => {
    //   checkboxGroup.toggleAll();
    // };
    // 轮胎类型，只可以选一家经销商,20210423潘静又改需求了，致友计划也只可以选一家经销商
    const resetResult = (type, result, resultArr) => {
      // 68,69,70 type === 'tyreData' &&
      if (result.length > 1 && !state.isManage) {
        const lastProdut = resultArr.filter(item => item.id === result[result.length - 1])
        const lastDealer = (lastProdut.length === 1 && lastProdut[0]['gsCode']) || ''
        if (lastDealer) {
          state.data.map((item, index) => {
            if (result.includes(item.id) && item.gsCode !== lastDealer) {
              // console.log("resetResult--do---toggle--->", item.gsCode, index);
              nextTick(() => {
                toggle(index)
              })
            }
          })
        }
      }
    }

    // EW 延保产品只可以选中唯一一款
    const resetEWResult = (type, result, resultArr) => {
      if (type === 'shopData' && result.length > 1 && !state.isManage) {
        const lastProduct = resultArr.filter(item => item.id === result[result.length - 1])[0]
        state.data.map((item, index) => {
          // 如果勾选了延保产品，取消其他产品，仅保留当前延保产品； 如果勾选了其他服务合约产品，取消已有延保产品
          if (lastProduct.isEW) {
            if (result.includes(item.id) && item.id !== lastProduct.id) {
              nextTick(() => {
                toggle(index)
              })
            }
          } else {
            if (result.includes(item.id) && item.isEW) {
              nextTick(() => {
                toggle(index)
              })
            }
          }
        })
      }
    }

    const deleteFn = async ({ id, isEW }) => {
      try {
        isEW ? await deleteEWShopping({ ids: id }) : await deleteShoppingInf({ data: [{ id }] })
        afterDelete([{ id, isEW }])
      } catch (e) {
        Toast({
          message: e.message || '删除失败',
          position: 'bottom'
        })
      }
    }
    const getDisabledBool = data => {
      // return  true-禁选  false-可选
      let res = false
      if (data._data.productType === 2) {
        res = !data.hasProduct && !state.isManage
      }
      if (data._data.productType === 3) {
        res = data._data.changedFlag && !state.isManage
      }
      return res
    }

    watch(
      () => state.result,
      n => {
        // console.log('result-->', state.type, n)
        if (state.type && n) {
          let resultArr = state.data.filter(item => n.includes(item.id))
          nextTick(() => {
            resetResult(state.type, n, resultArr)
            resetEWResult(state.type, n, resultArr)
          })
          updateCheckAll(state.type, !!(n.length >= 0 && resultArr.length === state.data.length), resultArr)
        }
      }
    )
    watch(
      () => state.data,
      n => {
        // console.log("data-------->", state.type, n, n.length);
        if (state.type) {
          let shoppingCarSelect = store.state.shoppingCarSelect || {}
          // console.log("shoppingCarSelect", shoppingCarSelect);
          if (shoppingCarSelect[state.type]) {
            state.result = n
              .filter(item => {
                if (state.type === 'planData') {
                  return shoppingCarSelect[state.type].includes(item.id)
                } else {
                  return item.hasProduct && shoppingCarSelect[state.type].includes(item.id)
                }
              })
              .map(({ id }) => id)
          }
          nextTick(() => {
            let resultArr = n.filter(item => state.result.includes(item.id))
            updateCheckAll(state.type, n.length == 0, resultArr)
          })
        }
      }
    )

    return {
      ...toRefs(state),
      toggle,
      checkAll,
      // toggleAll,
      deleteFn,
      updateCheckAll,
      alertTip,
      changeNum,
      getDisabledBool
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  padding: 0 10px;
  margin-bottom: 8px;
  background-color: #fff;
  text-align: left;
  font-size: 12px;
  color: #999;
}
.van-checkbox {
  display: inline-block;
  vertical-align: middle;
}
.deleteButton {
  height: 100%;
  margin-left: 5px;
  background-color: #c22d2d;
}
.van-cell-group {
  .van-cell {
    padding: 15px 20px;
  }
}
</style>
